import React, { useState } from "react";
import api, { domain } from "../../config/client.axios.api";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import path from "../../ultils/path";
import axios from "axios";

const VerifyNewAccount = () => {
  const [resetPassword, setResetPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();

  const handleChangePassword = async () => {
    setLoading(true);
    try {
      const resultChangePassword = await axios.put(
        `${domain}/account/password`,
        resetPassword,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (resultChangePassword?.data?.code === 200) {
        setLoading(false);
        toast.success(
          resultChangePassword?.data?.message || "Đổi mật khẩu thành công !"
        );
        navigate(path.SIGN_IN);
      } else {
        toast.success(
          resultChangePassword?.data?.message || "Đổi mật khẩu thất bại !"
        );
        setLoading(false);

        return;
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error ||
          "Change password failure. Please try again or contact Phototime"
      );
      setLoading(false);
    }
  };

  return (
    <div className="flex w-full h-screen justify-center items-center bg-black bg-opacity-60">
      <div className="flex flex-col mt-1 xl:w-[40%] lg:w-[60%] w-[90%] bg-white rounded-lg 2xl:p-[24px] xl:p-[20px] lg:p-[16px] md:p-[12px] p-[10px]">
        <span className="mb-4 text-red-500 text-center">
          To ensure the security policy for PHOTOTIME franchise partners, please
          change your password to use the website in the safest way.
        </span>
        <span className="font-semibold">Change password</span>
        <div className="flex flex-col w-full">
          <span>Password current</span>
          <input
            onChange={(e) => {
              setResetPassword((prev) => ({
                ...prev,
                oldPassword: e.target.value,
              }));
            }}
            type="password"
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <div className="flex flex-col w-full">
          <span>New password</span>
          <input
            onChange={(e) => {
              setResetPassword((prev) => ({
                ...prev,
                newPassword: e.target.value,
              }));
            }}
            type="password"
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <div className="flex flex-col w-full">
          <span>Confirm new password</span>
          <input
            onChange={(e) => {
              setResetPassword((prev) => ({
                ...prev,
                confirmPassword: e.target.value,
              }));
            }}
            type="password"
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => {
            navigate(path.SIGN_IN);
          }}
        >
          <small className="mt-2 underline text-pink-500 font-semibold cursor-pointer">
            Return login
          </small>
        </div>
        <button
          onClick={handleChangePassword}
          disabled={loading}
          className="w-full flex mt-4 cursor-pointer hover:bg-opacity-85 justify-center items-center p-[6px] rounded-md bg-photo-time-pink-light"
        >
          {loading ? (
            <Spin indicator={<LoadingOutlined spin />} />
          ) : (
            <span className="text-white">Change password</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default VerifyNewAccount;
